import './configs/i18n';
import './index.scss';
import './styles';

import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { Provider } from 'react-redux';

import { KeycloakProvider, PrivateRoute } from '@wf/keycloak-axios-provider';

import App from './components/App';

import { isSentryEnabled } from './configs/sentry';
import { IS_DEV, PUBLIC_PATH } from './config';
import store from './store';

const container = document.getElementById('root')!;
const root = createRoot(container);

const WFRoutes = isSentryEnabled ? Sentry.withSentryReactRouterV6Routing(Routes) : Routes;

root.render(
  <Provider store={store}>
    <KeycloakProvider
      options={{
        onLoad: 'check-sso',
        silentCheckSsoRedirectUri: `${window.location.origin}${
          IS_DEV
            ? '/silent-check-sso.html'
            : PUBLIC_PATH?.endsWith('/')
            ? `${PUBLIC_PATH}silent-check-sso.html`
            : `${PUBLIC_PATH}/silent-check-sso.html`
        }`,
      }}
    >
      <BrowserRouter basename={PUBLIC_PATH}>
        <WFRoutes>
          <Route element={<PrivateRoute />} path="*">
            <Route element={<App />} path="*" />
          </Route>
        </WFRoutes>
      </BrowserRouter>
    </KeycloakProvider>
  </Provider>
);
